"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonHeaders = void 0;
var core_1 = __importDefault(require("@moralisweb3/core"));
var getCommonHeaders = function () { return ({
    'x-moralis-platform': 'JS SDK',
    'x-moralis-platform-version': core_1.default.libVersion,
    'x-moralis-build-target': 'node',
}); };
exports.getCommonHeaders = getCommonHeaders;
//# sourceMappingURL=getCommonHeaders.js.map